import { useEffect, type RefObject } from 'react';

/**
 * Publishes a pinned mobile action bar's height as `--mobile-action-bar-h` while [active], so the fixed
 * chat entry (the sticky "Ask {maestro}" bar, the round FAB) rides above it instead of covering it. The
 * same handshake Packs' Create bar and the Maestro Save bar run by hand.
 */
export function useMobileActionBarHeight(ref: RefObject<HTMLElement | null>, active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    const el = ref.current;
    if (!el) return undefined;
    const root = document.documentElement;
    const apply = () => root.style.setProperty('--mobile-action-bar-h', `${el.offsetHeight}px`);
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    return () => {
      observer.disconnect();
      root.style.removeProperty('--mobile-action-bar-h');
    };
  }, [ref, active]);
}
